import React from 'react';
import PropTypes from 'prop-types';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

const theme = createMuiTheme({
	palette: {
		primary: {
			main: '#002b5c'
		},
		text: {
			primary: '#FFFFFF',
			secondary: '#2a2929'
		}
	},
	typography: {
		fontFamily: 'Lato'
	},
	label: {
		color: '#0392ce'
	}
});

theme.typography.h1 = {
	...theme.typography.h1,
	fontWeight: 300,
	[theme.breakpoints.up('xs')]: {
		fontSize: '38px',
		lineHeight: '36px'
	},
	[theme.breakpoints.up('sm')]: {
		fontSize: '50px',
		lineHeight: '46px'
	},
	[theme.breakpoints.up('md')]: {
		fontSize: '60px',
		lineHeight: '56px'
	}
};

theme.typography.h2 = {
	...theme.typography.h2,
	fontWeight: 300,
	[theme.breakpoints.up('xs')]: {
		fontSize: '33px'
	},
	[theme.breakpoints.up('sm')]: {
		fontSize: '45px'
	},
	[theme.breakpoints.up('md')]: {
		fontSize: '55px'
	}
};

theme.typography.body1 = {
	...theme.typography.body1,
	fontWeight: 300,
	[theme.breakpoints.up('xs')]: {
		fontSize: '15px',
		lineHeight: '18px'
	},
	[theme.breakpoints.up('sm')]: {
		fontSize: '16px'
	},
	[theme.breakpoints.up('md')]: {
		fontSize: '18px',
		lineHeight: '24px'
	}
};

const Theme = ({ children }) => (
	<ThemeProvider theme={theme}>
		<StyledThemeProvider theme={theme}>{children}</StyledThemeProvider>
	</ThemeProvider>
);

export default Theme;

Theme.propTypes = {
	children: PropTypes.node.isRequired
};
